module.exports = __webpack_public_path__ + "img/carousel-5.b64902ec.jpg";